export default __webpack_public_path__ + "static/media/logo-with-text.4d65e7bb.png";